module.exports = __webpack_public_path__ + "img/IMG_2629_FoamcoreMatted.856789c5.jpg";